// src/components/common/Header.jsx
import React from "react";
import UserProfileDropdown from "./Avatar/UserProfileDropdown";
import './Header.css'
const Header = ({ title }) => {
  return (
    <header className="header-container">
      <h2 className="header-title">{title}</h2>
      <div className="header-profile">
        <UserProfileDropdown />
      </div>
    </header>
  );
};

export default Header;
